import { render, staticRenderFns } from "./TgDateRangeSelector.vue?vue&type=template&id=0bbb20b6"
import script from "./TgDateRangeSelector.vue?vue&type=script&lang=js"
export * from "./TgDateRangeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports